import { startOfDay } from 'date-fns';

interface ParseDateOptions {
  useStartOfLocalDay?: boolean;
}

/**
 * Parses the dateValue input into a Date object.
 * If dateValue is a Date object, it is returned as-is.
 * Otherwise, the dateValue string is checked for timestamp information;
 * if found, a new Date is created from the string, or midnight local time is assumed.
 *
 * @param options.useStartOfLocalDay - If true, extracts only the date part (YYYY-MM-DD)
 * and interprets it as midnight in the user's local timezone, ignoring any timezone info
 */
export const parseDateValue = (
  dateValue: Date | string,
  options: ParseDateOptions = {}
): Date => {
  const { useStartOfLocalDay = false } = options;

  if (dateValue instanceof Date) {
    return useStartOfLocalDay ? startOfDay(dateValue) : dateValue;
  }

  if (useStartOfLocalDay) {
    const dateOnly = dateValue.split('T')[0];
    return new Date(`${dateOnly}T00:00:00`);
  }

  if (hasTimestamp(dateValue)) {
    return new Date(dateValue);
  }
  return new Date(`${dateValue}T00:00:00`);
};

export const hasTimestamp = (dateString: string): boolean => {
  return /\d{2}:\d{2}/.test(dateString);
};
